import { useEffect, useState } from "react"
import { useApi } from "../api"
import { AppHeader } from "../components/AppHeader"
import { PledgeAccording } from "../components/PledgeAccording"
import { ICargo } from "../interfaces"

export const PledgeHistorPage = () => {
  const api = useApi('SAI')
  const [isMounted, setIsMounted] = useState(false)
  const [pledgeSettles, setPledgeSettles] = useState([])
  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true)
      api.getPledges((cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setPledgeSettles(cargo.info)
        }
      })
    }
  }, [api, isMounted])
  return (
    <>
      <AppHeader title="收益情況"></AppHeader>
      <div className="m-86" style={{ "background": "#fff" }}>

        <div id="accordion">
          <div className="card txt-14">
            <div className="card-header bg-light">
              <div className="card-link row mx-0">
                <div className="col px-0">質押編號</div>
                <div className="col px-0">質押日期</div>
                <div className="col px-0">投入金額</div>
              </div>
            </div>
          </div>
          {
            pledgeSettles.map((pledgeSettle) => {
              return <PledgeAccording
                key={pledgeSettle['pledgeId']}
                pledgeId={pledgeSettle['pledgeId']}
                dateAdd={new Date(pledgeSettle['dateAdd'])}
                amount={pledgeSettle['amount']}
                interestRate={pledgeSettle['interestRate']}
                pledgeSettles={pledgeSettle['pledgeSettles']}
              ></PledgeAccording>
            })
          }
        </div>
      </div>
    </>
  )
}